module.exports = __webpack_public_path__ + "02_long_black.b94bb48d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/02_long_black.png
// module id = PIr8
// module chunks = 0